const PREPARABLE_STATUSES = ['ORDER_IS_READY_TO_BE_EXECUTED_STATE', 'PREPARATION_STARTED_STATE'];

export const isOrderPreparationEnabled = (user) =>
    !!user?.logisticProvider?.customSettings?.external_console_order_preparation_enabled;

export const canPrepareOrder = (user, order) =>
    isOrderPreparationEnabled(user) && order.orderType === 'EXIT' && PREPARABLE_STATUSES.includes(order.status);
